<template>
  <div>
    <div class="menu">
      <ul>
        <li><router-link router-link to="/en"><img src='../../../static/images/england.jpg'></router-link></li>
        <li><router-link router-link to="/fr"><img src='../../../static/images/france.png'></router-link></li>
        <li><router-link router-link to="/es"><img src='../../../static/images/spain.png'></router-link></li>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      hash: 'home',
      screenWidth: document.documentElement.clientWidth,
      screenHeight: window.innerHeight,
      menuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    }
  },
  mounted() {
    let context = this
    window.setInterval(function() {
      this.screenWidth = document.documentElement.clientWidth
      this.screenHeight = window.innerHeigh
    }, 100)
  }
}
</script>

<style scoped>

li a:hover {
  border-bottom: 2px solid #fff133;
}

a img {
  cursor: pointer;
  border: none;
}

.menu {
  top: -1px;
  left: 0px;
  margin: 0;
  position: fixed;
}
.menu ul{
  width: 60%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  margin-left: 0;
}

.menu li {
  padding: 1.5em;
  list-style-type:none;
}

.menu img {
  width: 3em;
}
</style>



// WEBPACK FOOTER //
// LanguageMenu.vue?3d0a194b